import { Space, Tabs } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { checkPermission } from 'utils/utils';
import CustomerSummaryReport from '../CustomerSummryReport';
import PayrollSummaryReport from '../PayrollSummaryReport';
import TimeSummaryReport from '../TimeSummaryReport';
import styles from './index.module.scss';
import ExportData from 'components/Global/ExportData';

// type Props = {};

const ReportsMain = () => {
	const [queryParams, setQueryParams] = useSearchParams();
	const [selectedReport, setSelectedReport] = useState(
		queryParams.get('reportTab') || '1'
	);

	const [selectedPayPeriod, setSelectedPayPeriod] = useState<string | null>(
		queryParams.get('payPeriod') || localStorage.getItem('payPeriod') || null
	);

	const [timeSummrySearchValue, setTimeSummrySearchValue] = useState<string>('');
	const [timeSummaryFilterValue, setTimeSummaryFilterValue] = useState<any>({});

	const [payrollSummarySearchValue, setPayrollSummarySearchValue] = useState<string>('');
	const [payrollSummaryFilterValue, setPayrollSummaryFilterValue] = useState<any>({});


	const navigate = useNavigate();

	const handleChangeReport = (e: any) => {
		setSelectedReport(e);
	};

	const { timeSummaryData, payRollSummaryData } = useSelector(
		(state: any) => state.reports
	);
	
	const selectedCompanyPermission = useSelector(
		(state: any) => state?.companies?.selectedCompanyDetails?.role?.permissions
	);

	const isTimeSummaryPermission = checkPermission(selectedCompanyPermission, {
		permissionName: 'Time Summary',
		permission: ['view'],
	});

	const isPayrollSummaryPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Payroll Summary',
			permission: ['view'],
		}
	);

	const isCustomerSummaryPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Customer Overview',
			permission: ['view'],
		}
	);

	const items = [];

	if (isTimeSummaryPermission) {
		items.push({
			key: '1',
			label: 'Time Summary Report',
			children: (
				<>
					{timeSummaryData?.timeActivitySummary &&
						timeSummaryData?.timeActivitySummary.length > 0 && (
							<div className={styles['time-summary-report__tabs-header']}>
								<Space className="search-filter-export">
									<ExportData
										moduleName="timeSummaryReport"
										params={{
											payPeriodId: selectedPayPeriod,
											filterValue:timeSummaryFilterValue,
											searchValue:timeSummrySearchValue,
										}}
									/>
								</Space>
							</div>
						)}
					<div className={styles['time-summary-report']}>
						<TimeSummaryReport
							selectedPayPeriod={selectedPayPeriod}
							setSelectedPayPeriod={setSelectedPayPeriod}
							searchValue={timeSummrySearchValue}
							setSearchValue={setTimeSummrySearchValue}
							filterValue={timeSummaryFilterValue}
							setFilterValue={setTimeSummaryFilterValue}
							setQueryParams={setQueryParams}
						/>
					</div>
				</>
			),
		});
	}

	if (isPayrollSummaryPermission) {
		items.push({
			key: '2',
			label: 'Payroll Summary Report',
			children: (
				<>
					<div className={styles['payroll-summary-report__tabs-header']}>
						{payRollSummaryData && payRollSummaryData.length > 0 && (
							<Space className="search-filter-export">
								<ExportData
									moduleName="payrollSummaryReport"
									params={{
										payPeriodId: selectedPayPeriod,
										filterValue: payrollSummaryFilterValue,
										searchValue: payrollSummarySearchValue,
									}}
								/>
							</Space>
						)}
					</div>
					<div className={styles['payroll-summary-report']}>
						<PayrollSummaryReport
							selectedPayPeriod={selectedPayPeriod}
							setSelectedPayPeriod={setSelectedPayPeriod}
							searchValue={payrollSummarySearchValue}
							setSearchValue={setPayrollSummarySearchValue}
							filterValue={payrollSummaryFilterValue}
							setFilterValue={setPayrollSummaryFilterValue}
							setQueryParams={setQueryParams}
						/>
					</div>
				</>
			),
		});
	}

	if (isCustomerSummaryPermission) {
		items.push({
			key: '3',
			label: 'Customer Summary Report',
			children: (
				<>
					<div className={styles['customer-summary-report']}>
						<CustomerSummaryReport />
					</div>
				</>
			),
		});
	}

	useEffect(() => {
		if (selectedCompanyPermission && selectedCompanyPermission.length) {
			if (isTimeSummaryPermission) {
				setSelectedReport('1');
			} else if (isPayrollSummaryPermission) {
				setSelectedReport('2');
			} else if (isCustomerSummaryPermission) {
				setSelectedReport('3');
			} else {
				navigate('/unauthorized');
			}
		}
	}, [
		isTimeSummaryPermission,
		isPayrollSummaryPermission,
		isCustomerSummaryPermission,
		selectedCompanyPermission,
	]);

	return (
		<div className={styles['reports-main']}>
			<Tabs
				defaultActiveKey="1"
				items={items}
				activeKey={selectedReport}
				key={selectedReport}
				tabBarStyle={{
					paddingLeft: '20px',
					fontSize: '18px',
				}}
				onChange={(e) => {
					handleChangeReport(e);
				}}
			/>
		</div>
	);
};

export default ReportsMain;
